<template>
    <ui-crud title="Labour Rates" subtitle="Manage the rates associated with labour items." :fetch="fetch"
             groupBy="group_name">

        <!-- Filters -->
        <template #filters="{ debouncedRefresh }">
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"
                          @input="debouncedRefresh()"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
        </template>

        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                    :title="item.name"
                    :subtitle="item.unit_per_hour + ' ' + item.uom + ' per hour'"
                    :metadata="[
                    item.can_view.buy_rate ? `Buy ${$options.filters.toCurrency(item.buy_unit_rate)} Per ${item.uom}` : false,
                    item.can_view.sell_rate ?`Sell ${$options.filters.toCurrency(item.sell_unit_rate)} Per ${item.uom}` : false
                    ]"
                    :active="active"
                    @click="select()"
            ></ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ addItem }">
            <labour-rates-form :key="`form-key-${formKey}`" :can-view-buy-rate="canViewBuyRate"
                               :can-view-sell-rate="canViewSellRate" :add-item="addItem" :buy-day-rate="buyDayRate"
                               :item-added="updateLabourRateDefaults"
                               :buy-hours-in-shift="buyHoursInShift" :sell-day-rate="sellDayRate"
                               :sell-hours-in-shift="sellHoursInShift"></labour-rates-form>
        </template>

        <!-- Edit form. -->
        <template #edit="{ selectedItem, setEditMode }">
            <labour-rates-form :key="`form-key-${formKey}`" :buy-day-rate="buyDayRate"
                               :buy-hours-in-shift="buyHoursInShift"
                               :edit="setEditMode" :item="selectedItem"
                               :sell-day-rate="sellDayRate" :sell-hours-in-shift="sellHoursInShift"></labour-rates-form>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem, showCreateButton, createNew }">
            <labour-rates-show :edit="setEditMode" :item="selectedItem"
                               :new-action="createNew" :removeItem="removeItem"
                               :show-new-action="showCreateButton"></labour-rates-show>
        </template>
    </ui-crud>
</template>

<script>
import {LabourRate} from '@models'

export default {
    data() {
        return {
            search: '',
            buyDayRate: 175.00,
            sellDayRate: 200.00,
            sellHoursInShift: 8,
            buyHoursInShift: 7,
            formKey: 1,
            canViewBuyRate: false,
            canViewSellRate: false,
        }
    },
    computed: {},
    methods: {
        updateLabourRateDefaults(item) {
            this.updateDefaultsFromRate(item);
        },
        updateDefaultsFromRate(item) {
            this.buyDayRate = item.buy_day_rate;
            this.buyHoursInShift = item.buy_hours_in_shift;
            this.sellDayRate = item.sell_day_rate;
            this.sellHoursInShift = item.sell_hours_in_shift;
            this.formKey = this.formKey + 1;
            this.canViewSellRate = item.can_view.sell_rate;
            this.canViewBuyRate = item.can_view.buy_rate;
        },
        async fetch() {
            let rates = await LabourRate.search(this.search)
            let lastItem = _.maxBy(rates, 'id');

            if (lastItem) {
                this.updateDefaultsFromRate(lastItem);
            }

            return rates;
        },
    }
}
</script>
